import { render } from "./NewDestinations.vue?vue&type=template&id=05b01a6e"
import script from "./NewDestinations.vue?vue&type=script&lang=js"
export * from "./NewDestinations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__